import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Text, SelectBox } from "sunrise-ui";
import { Grid } from "@material-ui/core";
import "./Bills.scss";
import List from "./List";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { getBillData } from "../../redux/reducers/billReducer";
import Loader from "../../utilities/Loader";
import dateFormat from "../../utilities/dateFormat";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import { compareDates } from "../../utilities/getDateUtils";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import NoDataScreen from "../../utilities/NoDataScreen";

const Bills = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [justLoaded, setJustLoaded] = useState(true);
  const [projectName, setProjectName] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [dataToDownload, setDataToDownload] = useState([]);
  //filter date
  const [filterDate, setfilterDate] = useState<any>({
    from: "",
    to: "",
  });
  const allProject: any = useSelector(
    (state: any) => state.PROJECT.allProjectData
  );
  const billsData: any = useSelector((state: any) => state.BILLS.billsData);
  const loading: any = useSelector((state: any) => state.BILLS.loading);
  const profileData = useSelector((state: any) => state.PROFILE.profileDetails);

  const generateBillData = (bill: any) => {
    return {
      BillReferenceNumber: bill?.billReferenceNumber,
      BillType: bill?.billType,
      UploadedDate: dateFormat(bill?.createdAt.split("T")[0]),
      UploadedBy: bill?.projectAndUserDetails?.userName,
      GrossAmount: bill?.grossBillAmount,
      Description: bill?.description,
      SnapShort: bill?.snapShort,
      status: bill?.billStatus[0]?.status,
    }
  }

  useEffect(() => {
    setJustLoaded(false);
    let data = billsData?.map((val: any) => generateBillData(val));
    setDataToDownload(data);
  }, [billsData]);
  console.log(billsData);
  useEffect(() => {
    if (allProject) {
      setProjectList(() => allProject.map((val: any) => val.projectName));
    }
  }, [allProject]);

  useEffect(() => {
    dispatch(
      getAllProjectData({
        endPoint: `project/get-all-projects`,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setJustLoaded(true);
    //if (justLoaded === true) {
    if (profileData) {
      if (Array.isArray(allProject)) {
        const project_id: any = allProject?.find(
          (val: any) => val?.projectName === projectName
        )?._id;
        if (project_id) {
          dispatch(
            getBillData({
              endPoint: `manage-bill/get-bills-by-ac&ad?projectId=${project_id}&userId=${profileData?.data?._id}`,
            })
          );
        }
      }
    }
    // }
    // eslint-disable-next-line
  }, [projectName]);
  console.log(justLoaded);
  const fields = [
    {
      header: "Reference Number",
      value: "BillReferenceNumber",
      search: true,
    },
    {
      header: "Uploaded Date",
      value: "UploadedDate",
      search: true,
    },
    {
      header: "Uploaded By",
      value: "UploadedBy",
      search: true,
    },
    {
      header: "Bill Type",
      value: "BillType",
      search: true,
    },
    {
      header: "Gross Amount (Rs)*",
      value: "GrossAmount",
      search: true,
    },
    {
      header: "Comments/Remarks",
      value: "Description",
      search: true,
      action: function (obj: any) {
        return (
          <Text type="normal" fonts="normal" className={`f14 fw500 truncate`}>
            {obj.Description}
          </Text>
        );
      },
    },
    {
      header: "Bill Snapshot",
      value: "SnapShort",
      format: "image"
    },
    {
      header: "Bill Status",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="normal"
            fonts="normal"
            className={`f14 mt0 mb0 fw500 capitalize ${obj?.status === "approved" ? "text--success" : "text--danger"
              }`}
          >
            {obj.status}
          </Text>
        );
      },
    },
  ];

  return (
    <Sidebar>
      <Grid className="p1 bills_wrapper">
        <Text
          fonts="normal"
          type="normal"
          fontSize={18}
          className="mt0 mb0 fw500"
        >
          Select Project
        </Text>
        <Grid className="mb-1 d-flex">
          <Grid className="mr-1 selectProject">
            <SelectBox
              data={projectList}
              placeHolder="Select Project"
              defaultVal={projectName}
              onChange={(e) => {
                let target = { ...e };
                setProjectName(target.target.value);
              }}
              borderColor={"primary"}
            />
          </Grid>
          <Grid className="filter_data">
            <FilterComponent
              handleFilterDate={() => {
                const data = { ...filterDate };
                if (data?.from && data?.to) {
                  const filterTable = billsData.filter(
                    (item: any) =>
                      compareDates(item?.createdAt.split("T")[0], data) && item
                  );
                  let data2 = filterTable?.map((val: any) => generateBillData(val));
                  setDataToDownload(data2);
                }
              }}
              setValue={setfilterDate}
              value={filterDate}
              resetAll={() => {
                setfilterDate({ from: "", to: "" });
                const data = billsData.map((val: any) => generateBillData(val));
                setDataToDownload(data);
              }}
              size="medium"
            />
          </Grid>
        </Grid>
        {projectName.length > 0 ? (
          loading ? (
            <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
          ) : dataToDownload.length > 0 ? (
            <Grid className="mt1">
              <List
                listData={dataToDownload}
                fields={fields}
                title={`Bill Details`}
                sizeType="large"
                dataToDownload={dataToDownload}
              />
            </Grid>
          ) : (
            <div className="mt4">
              <NoDataScreen text="No bill details for selected project." />
            </div>
          )
        ) : (
          <SelectOptionMsg text="Please choose project from dropdown to see bills." />
        )}
      </Grid>
    </Sidebar>
  );
};

export default Bills;
